import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import SiderTopic from '../../../../components/siderTopic';
import NewsSiderContent from '../../../../components/newsSiderContent';

class FTSiderBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { nav, data },
        } = this.props;

        return (
            <div>
                <SiderTopic content={nav} />
                <NewsSiderContent content={data} hasTopic />
            </div>
        );
    }
}

export default errorBoundary(FTSiderBox);
